export default Object.freeze({
    MY_PATIENTS_LIMIT: 10,
    resultOptions: [
		{ text: 'Urgencias', value: 1 },
		{ text: 'Consultas médicas de primer nivel o de especialidades', value: 2 },
		{ text: 'Recomendaciones de autocuidado', value: 3 },
		{ text: 'El usuario no responde al teléfono', value: 4 },
    ],

	employmentTypes: {
		0: 'Trabajo de oficina o similar que puedo realizar en cualquier lugar (por ejemplo, progamador o administrativo)',
		1: 'Trabajo cara a cara donde necesito estar en contacto con clientes y otras personas (por ejemplo, vendedor de tienda)',
		2: 'Trabajo al aire libre con contacto limitado con otras personas (por ejemplo, conductor de camión)',
		3: 'Trabajo cara a cara con mucha exposición a la población de riesgo (por ejemplo, farmacéutico, enfermero, médico, trabajador de hospital, etc)',
		4: 'No tengo un trabajo reglado y sólo hago quehaceres de la casa o similar',
		5: 'Temporalmente no puedo trabajar por enfermedad, cuarentena, o estoy buscando un nuevo trabajo'
	},

	homeBuildingTypes: {
		0: "Vivo en un departamento pequeño",
		1: "Vivo en un departamento grande",
		2: "Vivo en una casa de una planta",
		3: "Vivo en una casa de dos o más plantas o en un dúplex"
	},

	rsaKeys: {
		publicKey: process.env.VUE_APP_PUBLIC_KEY,
		privateKey: process.env.VUE_APP_PRIVATE_KEY
    },

	dbCollectionSuffix : '_test',
	accessToken: 'mc_access_token',
	apiBaseURL: process.env.VUE_APP_API_BASE_URL
})